var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4, _rect6, _rect7, _rect8, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleItemsAllIncluded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 122,
    viewBox: "0 0 162 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 121,
    rx: 4.5,
    fill: "#F8F8F8",
    stroke: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 101,
    width: 36,
    height: 9,
    rx: 4.5,
    fill: "#68C598"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.718 15H33.2824C30.9173 15 29 19.2533 29 24.5V81.5C29 86.7467 30.9173 91 33.2824 91H128.718C131.083 91 133 86.7467 133 81.5V24.5C133 19.2533 131.083 15 128.718 15Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0054,
    y: 27.5703,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 35.5703,
    width: 30,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 39.998,
    width: 25,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 24H47V48H71V24ZM69.9633 25.0801H48.0796V46.9801H69.9633V25.0801Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8977 40.668L56.1438 33.5371L49.2866 43.8228H58.6893L58.6543 43.8728H68.2543L63.4543 37.0156L60.8977 40.668Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8598 34.9775C66.3923 34.9775 67.6347 33.7478 67.6347 32.2309C67.6347 30.7141 66.3923 29.4844 64.8598 29.4844C63.3273 29.4844 62.085 30.7141 62.085 32.2309C62.085 33.7478 63.3273 34.9775 64.8598 34.9775Z",
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 87.0054,
    y: 60.7109,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 68.7109,
    width: 30,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 73.1387,
    width: 25,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 57.1406H47V81.1406H71V57.1406ZM69.9633 58.2207H48.0796V80.1207H69.9633V58.2207Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8977 73.8086L56.1438 66.6777L49.2866 76.9634H58.6893L58.6543 77.0134H68.2543L63.4543 70.1562L60.8977 73.8086Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8598 68.1181C66.3923 68.1181 67.6347 66.8884 67.6347 65.3716C67.6347 63.8547 66.3923 62.625 64.8598 62.625C63.3273 62.625 62.085 63.8547 62.085 65.3716C62.085 66.8884 63.3273 68.1181 64.8598 68.1181Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleItemsAllIncluded);
export default __webpack_public_path__ + "static/media/multiple-items-all-included.d3e106a1e79b445dcccc357f5ba4094e.svg";
export { ForwardRef as ReactComponent };